module.exports = __webpack_public_path__ + "static/media/eyelashes06.4cc4fdfe.jpg";